/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../../util.type';
import { shorten } from '../iso-string';

/**
 * @import { AnalyticsGroup } from './analytics-group'
 */

export default {
  name: literal('analyticsGroup'),
  methods: {
    /** @type {(this: AnalyticsGroup) => string} */
    toString() {
      // TODO: Předělat na standardní ISO 8601 zápis pro intervaly včetně možného
      // zkrácení. Nyní skoro standardně, ale neumí všechny případy (jen zkrácení
      // při stejném dnu). A není jasné jak s TZ, zda se má `Z` opakovat.
      const opened = shorten(this.opened);
      let closed = shorten(this.closed);
      if (closed.slice(0, 11) === opened.slice(0, 11)) {
        closed = closed.slice(11);
      }
      return `AnalyticsGroup id=${this.id} (${opened}/${closed})`;
    }
  }
  // TODO #389: Kvůli problémům s non-eager (ne)načítáním raději opuštěno.
  // Viz poznámky ve Store.
  // relations: {
  //   hasMany: {
  //     analyticsCounter: {
  //       localField: 'analyticsCounters',
  //       foreignKey: 'analyticsGroupId'
  //     }
  //   }
  // }
};
